import { apiClient, API_PRX } from '@indipia/shared';

export interface LandingStats {
  agentDownloadCount: number | null;
  activeMemberCount: number | null;
  siteRegisteredCount: number | null;
  siteInProgressCount: number | null;
  collectedDtm: string | null;
}

export async function fetchLandingStats(): Promise<LandingStats> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/public/landing-stats`);
  return res.data?.data as LandingStats;
}
